import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../lib/cn.js";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  readonly invalid?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid === true ? true : undefined}
      className={cn(
        "h-11 w-full rounded-md border px-3 text-base",
        "bg-elevated text-fg placeholder:text-dim",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid === true
          ? "border-danger focus-visible:ring-danger"
          : "border-line",
        className,
      )}
      {...rest}
    />
  );
});
